import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Topbar from "./pages/global/Topbar";
import Sidebar from "./pages/global/Sidebar";
import Dashboard from "./pages/dashboard";
import Team from "./pages/user";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Login from "./pages/login";
import Footer from "./pages/global/Footerbar";
import { useCookies } from "react-cookie";
import Role from "./pages/roles";
import Company from "./pages/company";
import Accounts from "./pages/accounts";
import ErrorPage from "./pages/notFound";
import Statement from "./pages/statement";
import ChangePasswordPage from "./pages/changePassword";
import { jwtDecode } from "jwt-decode";
import Message from "./pages/messages";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [cookie] = useCookies(["token"]);
  const decoded = cookie["token"] ? jwtDecode(cookie["token"]) : null;
  const jsonData = decoded ? JSON.parse(decoded.userInfo) : null;
  const firstTime = jsonData
    ? jsonData.first_time && jsonData.roles.name !== "Super Admin"
    : null;

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div style={{ display: "flex" }}>
          {cookie["token"] && !firstTime && <Sidebar isSidebar={isSidebar} />}
          <div
            className="app"
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
              position: "relative",
            }}
          >
            <main className="content" style={{ flexGrow: 1 }}>
              {cookie["token"] && !firstTime && (
                <Topbar setIsSidebar={setIsSidebar} />
              )}

              <Routes>
                <Route
                  path="/"
                  element={<Dashboard />}
                  errorElement={<ErrorPage />}
                />
                <Route
                  path="/login"
                  element={<Login />}
                  errorElement={<ErrorPage />}
                />
                <Route
                  path="/users"
                  element={<Team />}
                  errorElement={<ErrorPage />}
                />
                <Route
                  path="/changePassword"
                  element={<ChangePasswordPage />}
                  errorElement={<ErrorPage />}
                />
                 <Route
                  path="/company"
                  element={<Team />}
                  errorElement={<ErrorPage />}
                />
                <Route
                  path="/companies"
                  element={<Company />}
                  errorElement={<ErrorPage />}
                />
                <Route
                  path="/accounts"
                  element={<Accounts />}
                  errorElement={<ErrorPage />}
                />
                <Route
                  path="/statement"
                  element={<Statement />}
                  errorElement={<ErrorPage />}
                />
                <Route
                  path="/roles"
                  element={<Role />}
                  errorElement={<ErrorPage />}
                />
                <Route path="/message" element={<Message />} />
                <Route path="*" element={<ErrorPage />} />
              </Routes>
            </main>
            {cookie["token"] && !firstTime && (
              <Footer
                style={{
                  position: "fixed",
                  bottom: 0,
                  width: "100%",
                  zIndex: 999,
                }}
              />
            )}
          </div>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
